import {
  LabType,
  validTimeZones,
} from 'context/LabSchedulingContext/LabSchedulingProvider'
import { Provider } from 'hooks/useUser/useUser'

export enum BaseAppointmentType {
  APPOINTMENT = 'appointment',
  LAB = 'lab',
}

export type AppointmentType = {
  id: string
  reason: string
  category: string
  followupModule: string
}

export enum LabAppointmentStatus {
  BOOKED = 'booked',
  COMPLETED = 'completed',
}

export type Appointment = {
  id: string
  sourceId: string
  user: string
  provider: Provider
  time: string
  isCancelled?: boolean
  videoCallLink?: string
  type: AppointmentType
  appointmentType: BaseAppointmentType.APPOINTMENT
}

export type LabAppointment = {
  id: string
  labProvider: LabType
  labLocation: string
  addressSearched: string
  confirmationNumber: string
  confirmationUrl: string | null
  status: string
  qrCode: string
  labCode: string
  scheduledAt: string
  appointmentType: BaseAppointmentType.LAB
  timezone: validTimeZones
}
